export default __webpack_public_path__ + "static/media/performance.bdb67c6f.jpg";